import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "../api";

const AuditTracker = () => {
  const location = useLocation();
  const queueRef = useRef([]);
  const lastVisitRef = useRef({ route: "", at: 0 });

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || location.pathname === "/") return;
    const route = `${location.pathname}${location.search}`;
    const now = Date.now();
    if (
      lastVisitRef.current.route === route &&
      now - lastVisitRef.current.at < 30000
    ) {
      return;
    }
    lastVisitRef.current = { route, at: now };
    queueRef.current.push({
      action: "page_visit",
      category: "navigation",
      summary: `Visited ${location.pathname}`,
      page: location.pathname,
      route,
    });
  }, [location.pathname, location.search]);

  useEffect(() => {
    const flush = async () => {
      if (!queueRef.current.length || !localStorage.getItem("token")) return;
      const entries = queueRef.current.splice(0, 25);
      try {
        await axios.post("/audit-logs/client", { entries });
      } catch (_) {
        queueRef.current = [...entries, ...queueRef.current].slice(0, 50);
      }
    };

    const interval = window.setInterval(flush, 5000);
    const handleVisibility = () => {
      if (document.visibilityState === "hidden") flush();
    };
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibility);
      window.clearInterval(interval);
      flush();
    };
  }, []);

  return null;
};

export default AuditTracker;
